module.exports = __webpack_public_path__ + "img/paper.5beaeb8b.svg";